import SecureLs from 'secure-ls'

const secureLocalStorage = new SecureLs({ encodingType: 'aes' })

export default secureLocalStorage
